import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import { SoldConfigurationsType } from '@mm/state/model/CampaignsModel';

const validationSchema = Yup.object().shape({
  teamId: Yup.string().trim().required('Workspace Required'),
  slackChannelId: Yup.string().trim().required('Channel Required'),
  content: Yup.string().trim().required('Message Required'),
});

const formFields = {
  teamId: 'teamId',
  slackChannelId: 'channelId',
  content: 'content',
};

const validate = () => async (values: SoldConfigurationsType) => {
  let errors = {};
  try {
    await validationSchema.validate(values.unicorn.notifications.slack, {
      abortEarly: false,
    });
  } catch (e) {
    errors = yupToFormErrors(e);
  }
  return errors;
};

const SOLDSlackHelper = { formFields, validate };

export default SOLDSlackHelper;
